module.exports = __webpack_public_path__ + "static/media/Jaime.ca2ef948.png";